/**
 * Location requests
 */
import API from '@/api/base.js';
export default {
    getLocationById(id){
        return API.get(`/location/${id}`,{},'Location by ID');
    },
    getLocations(data){
        ///location?activities=1,2&amenities=2,3&status=1&sw_lat=1&sw_lng=1&ne_lat=2&ne_lng=2&from=1578092400000&to=1578265200000
        //
        return API.get('/location?status=2',data,'Locations');
    },
    getMyLocations(userId,data){
        let id=(data && data.id)?data.id:null;
        //Tweak to receive location for admin edit
        return (id)?this.getLocationById(id): API.get(`/user/${userId}/location`,data,'My Locations');
    },
    createLocation(data){
        let id=(data && data.id)?data.id:'';
        return API.post(`/location/${id}`,data,'Location');
    },
    updateLocation(data){
        return this.createLocation(data);
    },
    deleteLocation(data){
        return API.delete('/location',data,'Location');
    },
    finishLocation(data){
        return API.post('/user/finish',data,'Location');
    },
    checkPricing(price){
        return API.get(`/price?hostPrice=${price}`,{},'Check pricing');
    },
}